<template>
  <div class="information-page">
    <HeaderCommon></HeaderCommon>
    <div class="pc-information-container">
      <div class="info-inner">
        <div class="crumbs">
          <i class="crumbs-icon"></i>
          <a href="/" v-text="$t('info.home')"></a>
          <i class="el-icon-arrow-right"></i>
          <span v-text="$t('info.informations')"></span>
        </div>
        <div class="tags">
          <ul class="tag-items">
            <li class="tag-item" :class="{'current':currentTag==='all'}" @click="selectTag('all')">
              <div class="tag-text" v-text="$t('info.all')"></div>
            </li>
            <li
              class="tag-item"
              :class="{'current':currentTag===item.id}"
              @click="selectTag(item.id)"
              v-for="item in tags"
              :key="item.id"
            >
              <div class="tag-text" v-text="item.lable"></div>
            </li>
          </ul>
        </div>
        <div class="info-lists-wrapper">
          <ul class="info-contents">
            <li
              class="info-item"
              :class="{'top':item.isTop=='Y'}"
              :key="item.id"
              v-for="item in infos"
            >
              <a :href="'/info_detail?no='+item.id" target="_blank" class="info-link">
                <div class="info-item-title">
                  <span class="list-icon" v-if="item.isTop=='N'"></span>
                  <span class="list-top" v-if="item.isTop=='Y'" v-text="$t('info.top')"></span>
                  <span v-text="item.title" class="info-title-text"></span>
                </div>
                <div
                  class="info-item-date"
                  v-text="item.publishTime.substring(0,10).replace(/-/g,'.')"
                ></div>
              </a>
            </li>
          </ul>
          <div class="info-pagination-wrapper">
            <el-pagination
              background
              :page-size="pageSize"
              :page-count="pageCount"
              :current-page="currentPage"
              layout="prev, pager, next, slot"
              :total="total"
              class="info-pagination"
              @current-change="handleCurrentPage"
              hide-on-single-page
            >
              <button class="home-pager" @click="jumpPage('home')" :title="$t('info.first_page')">
                <i class="el-icon el-icon-d-arrow-left"></i>
              </button>
              <button class="end-pager" @click="jumpPage('end')" :title="$t('info.end_page')">
                <i class="el-icon el-icon-d-arrow-right"></i>
              </button>
            </el-pagination>
          </div>
        </div>
        <ScrollToTop></ScrollToTop>
      </div>
    </div>
    <div class="wap-infos">
      <div class="info-container">
        <div class="info-content">
          <div class="infos-tags">
            <ul class="info-tag-items">
              <li
                class="tag-item"
                :class="{'current':currentTag==='all'}"
                @click="selectTag('all')"
              >
                <div class="tag-text" v-text="$t('info.all')"></div>
              </li>
              <li
                class="tag-item"
                :class="{'current':currentTag===item.id}"
                @click="selectTag(item.id)"
                v-for="item in tags"
                :key="item.id"
              >
                <div class="tag-text" v-text="item.lable"></div>
              </li>
            </ul>
          </div>
          <div class="info-list">
            <div
              class="infinite-list-wrapper info-lists-wrapper"
              :style="{height:contentHeight+'px',overflow:'auto'}"
            >
              <ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-immediate="false">
                <li
                  class="info-item"
                  :class="{'top':item.isTop=='Y'}"
                  :key="item.id"
                  v-for="item in wapInfos"
                >
                  <a :href="'/info_detail?no='+item.id" target="_blank" class="info-link">
                    <div class="info-item-title">
                      <span class="list-icon" v-if="item.isTop=='N'"></span>
                      <span class="list-top" v-if="item.isTop=='Y'" v-text="$t('info.top')"></span>
                      <span v-text="item.title" class="info-title-text"></span>
                    </div>
                    <div
                      class="info-item-date"
                      v-text="item.publishTime.substring(0,10).replace(/-/g,'.')"
                    ></div>
                  </a>
                </li>
              </ul>
              <p class="list-loading" v-if="loading">加载中...</p>
              <p class="nomore" v-if="noMore">没有更多了</p>
            </div>
            <ul class="info-contents"></ul>
          </div>
        </div>
      </div>
    </div>
    <FooterCommon></FooterCommon>
  </div>
</template>

<script>
import global from './common/common'
import HeaderCommon from './template/HeaderCommon'
import FooterCommon from './template/FooterCommon'
import ScrollToTop from './template/ScrollToTop'
import { getTagList, getArticlesList } from '../../request/api'
export default {
  data () {
    return {
      currentTag: 'all',
      pageSize: 15,
      pageCount: 5,
      currentPage: 1,
      total: 0,
      tags: [],
      infos: [],
      wapInfos: [],
      loading: false,
      contentHeight: 0,
      lang: '',
    }
  },
  methods: {
    load () {
      if (window.innerWidth >= 800) {
        return
      }
      this.loading = true
      this.currentPage++
      this.getArticles('wap')
      this.loading = false
    },
    selectTag (id) {
      this.currentTag = id
      this.currentPage = 1
      this.wapInfos = []
      if (window.innerWidth >= 800) {
        this.getArticles('pc')
      } else {
        this.getArticles('wap')
      }
    },
    jumpPage (val) {
      switch (val) {
        case 'home': // 跳转到首页
          this.currentPage = 1
          this.getArticles('pc')
          break
        case 'end': // 跳转到末页
          this.currentPage = Math.ceil(this.total / this.pageSize)
          this.getArticles('pc')
          break
      }
    },
    handleCurrentPage (currentPage) {
      if (this.currentPage === currentPage) {
        return
      }
      this.currentPage = currentPage
      this.getArticles('pc')
    },
    init () {
      var _this = this
      _this.setLang()
      setTimeout(function () {
        _this.calcuContentHeight()
      }, 500)
      window.addEventListener(
        'resize',
        function () {
          _this.calcuContentHeight()
        },
        false
      )
      this.getTags()
      this.getArticles('pc')
      this.getArticles('wap')
    },
    setLang () {
      this.lang = this.$cookies.get('language')
    },
    calcuContentHeight () {
      // 计算1rem的数值
      var vw = window.innerWidth / 100
      var tagsHeight = $('.info-tag-items').height()
      var windowHeight = window.innerHeight
      this.contentHeight = windowHeight - 50.5 * vw - tagsHeight // 计算满屏的最小高度
    },
    getTags () {
      var that = this
      var localTagsList = localStorage.getItem('tagsList')
      if (localTagsList) {
        // 先读取缓存
        that.tags = JSON.parse(localTagsList)
      }
      getTagList({ language: this.lang || global.initLang })
        .then(res => {
          if (res) {
            that.tags = res
            localStorage.setItem('tagsList', JSON.stringify(res))
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getArticles (type) {
      var that = this
      var data = {
        language: this.lang || global.initLang,
        pageSize: that.pageSize,
        pageNo: that.currentPage
      }
      if (that.currentTag !== 'all') {
        data.tagIds = that.currentTag
      }
      getArticlesList(data)
        .then(res => {
          if (res && res.success) {
            if (type === 'pc') {
              that.infos = res.rows
            }
            if (type === 'wap') {
              for (var index = 0; index < res.rows.length; index++) {
                that.wapInfos.push(res.rows[index])
              }
            }
            that.total = res.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted () {
    this.init()
  },
  components: {
    HeaderCommon,
    FooterCommon,
    ScrollToTop
  },
  computed: {
    noMore () {
      return this.currentPage * this.pageSize >= this.total
    },
    disabled () {
      return this.loading || this.noMore
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/pc";
@import "~@/assets/scss/wap";
</style>



// WEBPACK FOOTER //
// src/components/pc/Information.vue